import { Controller } from "@hotwired/stimulus"

// Shows the day boxes or the day-of-month picker to match the "Repeats"
// choice. Presentation only: the form posts normally, and with JS off every
// field is simply visible. Used by the side panel's Repeats section, where
// an existing task is turned into a repeating one or back again.
export default class extends Controller {
  static targets = ["select", "weekly", "monthly", "submit"]

  connect() {
    this.initial = this.selectTarget.value
    this.sync()
  }

  sync() {
    const mode = this.selectTarget.value
    if (this.hasWeeklyTarget) this.weeklyTarget.hidden = mode !== "weekly"
    if (this.hasMonthlyTarget) this.monthlyTarget.hidden = mode !== "monthly"
    this.refreshSubmit()
  }

  // Any change re-enables Save; it starts disabled so the section never
  // looks like it has a pending edit when it does not.
  refreshSubmit() {
    if (!this.hasSubmitTarget) return
    this.submitTarget.disabled = false
    this.submitTarget.classList.remove("opacity-40", "cursor-not-allowed")
  }
}
